import React, { useState, useEffect } from "react";
import Banner from "../../components/Bannersection/banner";
import { AiOutlineArrowRight } from "react-icons/ai";
import { Helmet } from "react-helmet";

const PAGE_SIZE = 6;

function Projects() {
  const [allProjects, setAllProjects] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/json_files/project.json?v=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => {
        const active = data.filter((p) => p.isActive !== false);
        setAllProjects(active);
      })
      .catch((err) => console.error("Error loading projects:", err))
      .finally(() => setLoading(false));
  }, []);

  const visible = allProjects.slice(0, page * PAGE_SIZE);
  const hasMore = visible.length < allProjects.length;

  const pagename = [{ pagetitle: "Our Projects", subtitle: "Our Projects" }];

  return (
    <div>
      <Helmet>
        <title>Our Projects | Web & App Development Portfolio | DGi WORX Australia</title>
        <meta
          name="description"
          content="Explore DGi WORX's portfolio of completed projects across web development, app development, design, and digital marketing for Australian and global clients."
        />
        <meta
          name="keywords"
          content="dgiworx projects, web development portfolio, app development Australia, IT solutions portfolio, DGi WORX, digital projects, website design portfolio"
        />
        <meta property="og:title" content="Our Projects - DGi WORX - Showcase of Innovative IT Solutions" />
        <meta property="og:description" content="Explore a curated collection of projects by DGi WORX, highlighting our expertise in delivering innovative IT solutions across Australia and beyond." />
        <meta property="og:image" content="/assets/img/dgiworx-home-embedded.jpg" />
        <meta property="og:url" content="https://dgiworx.com.au/projects" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://dgiworx.com.au/projects" />
        <link rel="alternate" hreflang="en-au" href="https://dgiworx.com.au/" />
      </Helmet>

      <Banner items={pagename} />

      <section className="about-area tp-about-two py-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="tp-about-two-wrap mb-30 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-about-two-thumb">
                  <div className="tp-about-circle">
                    <div className="tp-about-circle-two">
                      <img src="/assets/img/project/project_about-1.jpg" alt="Our projects" loading="lazy" />
                    </div>
                  </div>
                </div>
                <div className="tp-about-two-thumb-shape tp-thumb-common fix">
                  <div className="tp-thumb-common-overlay wow"></div>
                  <img src="/assets/img/project/project_about-2.jpg" alt="web development" loading="lazy" />
                </div>
                <div className="tp-about-two-thumb-shape-two d-none d-md-block">
                  <img src="/assets/img/about/two/dote.png" alt="" loading="lazy" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tp-about-two-wrapper mb-30 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-section mb-40">
                  <span className="tp-section-sub-title">Exemplifying Our Expertise</span>
                  <h2 className="tp-section-title">Showcasing Our Mastery</h2>
                  <div className="tp-section-title-wrapper">
                    <p>
                      Welcome to the heart of our creativity and expertise. At DGi WORX, we take immense pride in the projects we've undertaken and successfully delivered. Each project is a testament to our dedication, innovation, and commitment to excellence.
                      <br /><br />
                      From captivating websites to dynamic mobile apps, our projects showcase the depth of our skills and the breadth of our capabilities â€” serving clients across Australia and globally.
                    </p>
                  </div>
                </div>
                <div className="tp-about-two-list">
                  <ul>
                    {["Diverse Portfolio", "Creative Excellence", "Client Success", "Technological Expertise", "Innovation and Ingenuity", "Inspiration Source"].map((item) => (
                      <li key={item}>
                        <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-about-two-shape">
          <div className="tp-about-two-shape-4">
            <img src="/assets/img/about/two/about-2-shape-2.png" alt="" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="py-50">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <div className="tp-section text-center mb-50">
                <span className="tp-section-sub-title">Explore Our Projects</span>
                <h2 className="tp-section-title">Our Recent Completed Projects</h2>
                <p>
                  DGi WORX has been helping technology startups, global brands, and Australian businesses create impactful software solutions.
                </p>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-50">
              <div className="spinner-border" role="status"></div>
            </div>
          ) : (
            <>
              <div className="row">
                {visible.map((project) => (
                  <div className="col-lg-6 col-md-12" key={project.id}>
                    <div className="tp-project-3-item mb-30 tp-thumb-common fix wow fadeInRight" data-wow-duration="1.2s" data-wow-delay=".6s">
                      <div className="tp-project-3-thumb">
                        <div className="tp-thumb-common-overlay wow"></div>
                        <img src={project.image} alt={project.title} loading="lazy" />
                      </div>
                      <div className="dgi-project-3-info d-flex justify-content-between align-items-center">
                        <div className="tp-project-3-content">
                          <span className="text-capitalize">{project.description}</span>
                          <h4 className="tp-project-3-title under-line-white">{project.title}</h4>
                        </div>
                        {project.url && (
                          <div className="tp-project-3-icon">
                            <a href={project.url} target="_blank" rel="noopener noreferrer">
                              <i><AiOutlineArrowRight className="fa-regular fa-arrow-right" /></i>
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {hasMore && (
                <div className="text-center mt-4">
                  <button className="tp-btn" onClick={() => setPage((p) => p + 1)}>
                    Load More
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </div>
  );
}

export default Projects;
